"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.array.some.js");
var _btnMixin = _interopRequireDefault(require("./btn-mixin"));
var _findParent = require("../mixins/find-parent");
var _utils = require("../utils");
var _util = require("./util");
var _toast = _interopRequireDefault(require("../toast"));
// import adapter from '@zz-common/native-adapter';

var COMPONENT_NAME = 'z-upload-btn';
var EVENT_ERROR = 'file-error';
var EVENT_ADDED = 'files-added';
var BEFORE_UPLOAD = 'before-uplaod';
var adapter;
if (!_utils.isServer) {
  adapter = require('@zz-common/native-adapter').default; // eslint-disable-line global-require
}
var _default = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "z-upload-btn"
    }, [_vm._t("default", [_c('div', {
      staticClass: "z-upload-btn-def"
    }, [_vm.$refs.btn ? _vm._t("btn") : _c('div', {
      staticClass: "z-upload-btn-wrapper"
    }, [_c('img', {
      staticClass: "z-upload-btn_img",
      attrs: {
        "src": _vm.parent.btnUploadImg,
        "alt": ""
      }
    }), _c('p', {
      staticClass: "z-upload-btn_info"
    }, [_vm._v(_vm._s(_vm.parent.btnUploadInfo))])])], 2)]), !_vm.parent.isAdaptIosUplaod ? _c('input', {
      staticClass: "z-upload-input",
      attrs: {
        "type": "file",
        "disabled": _vm.parent.disabled || _vm.disabled,
        "multiple": _vm.getMultiple,
        "accept": _vm.parent.accept || _vm.accept,
        "capture": _vm.parent.capture || _vm.capture
      },
      on: {
        "change": _vm.changeHandler,
        "click": _vm.clickHandler
      }
    }) : _c('input', {
      staticClass: "z-upload-input",
      attrs: {
        "type": "file",
        "disabled": _vm.parent.disabled || _vm.disabled,
        "accept": _vm.parent.accept || _vm.accept,
        "capture": _vm.parent.capture || _vm.capture
      },
      on: {
        "change": _vm.changeHandler,
        "click": _vm.clickHandler
      }
    })], 2);
  },
  name: COMPONENT_NAME,
  mixins: [_btnMixin.default, _findParent.FindParentMixin],
  props: {
    maxAllowCount: {
      type: Number,
      default: 10
    }
  },
  data: function data() {
    return {
      parent: {},
      uploadNum: 0,
      // 上传中的个数
      stanceNum: 0,
      // 占位图个数
      cameraDict: {},
      // 吊起相机 id 集合
      zljVersion: '0'
    };
  },
  computed: {
    getMultiple: function getMultiple() {
      // 历史问题，multiple 默认是 true，不能直接用 || 表达式
      if (this.parent.multiple === undefined) {
        return this.multiple;
      }
      return this.parent.multiple;
    }
  },
  mounted: function mounted() {
    var _this = this;
    if (!_utils.isServer && this.$expandAdapter) adapter = this.$expandAdapter;
    this.findParent('z-upload');
    if (adapter.in('zlj')) {
      adapter.wrap('getContextInfo')({
        success: function success(res) {
          _this.zljVersion = res && res.version || res.appVersion || '0';
        }
      });
    }
  },
  methods: {
    clickHandler: function clickHandler(e) {
      var _this2 = this;
      if (this.parent.disabled || this.disabled || !this.parent.initReady) {
        if (!this.parent.initReady) {
          (0, _toast.default)('网络错误，请刷新页面或稍后再试');
        }
        e.preventDefault();
        return;
      }
      this.parent.$emit(BEFORE_UPLOAD);
      this.parent.preventDefaultFun(e, function (shouldUpload) {
        if (shouldUpload === void 0) {
          shouldUpload = true;
        }
        if (!shouldUpload) {
          e.preventDefault();
          return;
        }

        // 在转转端内开启zzsdk上传
        if (_this2.parent.zzapp && (adapter.in('zz') || adapter.in('zzseller'))) {
          e.preventDefault();
          _this2.ZZSdkHandler();
        }

        // 在采货侠端内开启zzsdk上传
        if (_this2.parent.zzhunter && adapter.in('zzhunter')) {
          // 只传图片时才走端内
          if ((_this2.parent.accept || _this2.accept).indexOf('video') === -1) {
            e.preventDefault();
            _this2.ZZSdkHandler();
          }
        }

        // 在找靓机端内开启zzsdk上传
        if (_this2.parent.zlj && adapter.in('zlj')) {
          // 8.4.21以上端内可以上传视频
          if ((_this2.parent.accept || _this2.accept).indexOf('video') === -1 || (0, _utils.compareVersion)(_this2.zljVersion, '8.4.21') === 1) {
            e.preventDefault();
            _this2.ZLJSdkHandler();
          }
        }

        // 是微信环境，开启微信上传，微信config已经注册，同时不是上传视频
        if (_this2.parent.weixinUpload) {
          e.preventDefault();
          _this2.WeixinSdkHandler();
        }

        // 门店端内，新增zzStoreCapture仅拍照，app上传更改为手动调用upload接口上传以添加水印参数
        if (_this2.parent.zzapp && adapter.in('zzstore')) {
          console.log('执行~~zzStoreHandle');
          e.preventDefault();
          if (_this2.parent.zzStoreCapture) {
            _this2.ZZStoreCaptureSdkHandler();
          } else {
            _this2.ZZStoreSdkHandler();
          }
        }

        // 以上都不是，才触发原生的上传逻辑，选择照片，触发 changeHandler
      });
    },
    // ZZSdkHandler回调会多次执行，所以 this.uploadNum += 1 要提前执行，确保只加一个 loading 框
    // 而ZLJSdkHandler回调则以事件区分，每个事件执行一次，不需要提前执行
    ZZSdkHandler: function ZZSdkHandler() {
      var _this3 = this;
      if ((this.parent.accept || this.accept).indexOf('video') === -1) {
        // 上传图片
        if (this.parent.selectImageV2) {
          // 采用鉴定的特定api
          this.uploadNum += 1;
          adapter.wrap('selectImageV2')(Object.assign({}, this.parent.selectImageV2params), function (data) {
            _this3.handlerZZappUplaodV2(data);
          });
          return;
        }
        // 使用新的api
        if (this.parent.isSupportNewUploadApi) {
          var uplaodConfig = {
            'requestId': +new Date(),
            // 用来标识某次选图
            'images': {
              'supportAlbum': true,
              // 是否显示图片列表
              'supportCapture': true,
              // 是否支持拍摄图片
              'maxSelectedCount': this.parent.maxAllowApp || this.maxAllowCount,
              // 最大选取图片数量
              'supportEdit': false // 是否支持编辑（目前不支持，设置为false无效）
            },

            'videos': {
              'supportAlbum': false
            }
          };
          if (this.parent.capture || this.capture) {
            // 吊起相机
            uplaodConfig.images.supportAlbum = false;
            adapter.wrap('chooseMedia')(uplaodConfig, function (data) {
              _this3.handlerZZappUplaodV3(data);
            });
          } else {
            adapter.wrap('chooseMedia')(uplaodConfig, function (data) {
              _this3.handlerZZappUplaodV3(data);
            });
          }
        } else {
          // 使用老版的api
          if (this.parent.capture || this.capture) {
            // 吊起相机
            // 吊起相机因为是手动上传，所以不递增 uploadNum, 单独维护一个 id
            var id = Date.now().toString();
            this.cameraDict[id] = 'loading';
            adapter.wrap('getSystemCamera')(Object.assign({}, this.parent.getSystemCameraParameter), function (data) {
              _this3.handlerZZappUplaodCamera(data, id);
            });
          } else {
            this.uploadNum += 1;
            adapter.uploadPhotos(Object.assign({
              maxAllowCount: this.parent.maxAllowApp || this.maxAllowCount
            }, this.parent.uploadPhotoshParameter), function (data) {
              _this3.handlerZZappUplaod(data);
            });
          }
        }
      } else {
        // 上传视频
        this.uploadNum += 1;
        adapter.wrap('chooseMediaPhotos')(Object.assign({
          maxCount: this.parent.maxAllowApp || this.maxAllowCount
        }, this.parent.chooseMediaPhotosParameter), function (data) {
          _this3.handlerZZappUplaodMedia(data);
        });
      }
    },
    ZLJSdkHandler: function ZLJSdkHandler() {
      var _this4 = this;
      if ((this.parent.accept || this.accept).indexOf('video') === -1) {
        // 上传图片
        if (this.parent.capture || this.capture) {
          // 吊起相机
          adapter.wrap('getSystemCamera')(Object.assign({}, this.parent.getSystemCameraParameter), function (data) {
            var statusCode = data.statusCode,
              photoString = data.photoString,
              photoArray = data.data;
            if (+statusCode === 2) {
              // 准备上传
              // TODO: 客户端有问题，暂时不会触发这个事件，所以看不到 loading
              console.log('ready to upload');
              _this4.uploadNum += 1;
              _this4.showLoading();
            } else if (+statusCode === 1) {
              // 上传成功
              // 找靓机新版本数据格式有变化，兼容处理
              var photoResp = photoString || (photoArray === null || photoArray === void 0 ? void 0 : photoArray[0].photoString);
              // console.log('success', photoResp)

              var files = {
                progress: 1,
                status: _util.STATUS_SUCCESS,
                name: '',
                type: 'image/jpg',
                response: photoResp,
                url: photoResp,
                urlName: photoResp
              };
              _this4.hideLoading();
              _this4.parent.addAppFiles([files]);
            } else if (+statusCode === 0) {
              // 上传失败
              console.log('error', data);
              _this4.hideLoading(_util.STATUS_ERROR);
            }
          });
        } else if (_utils.isZLJNew) {
          // 找靓机新webview下没有uploadPhotos，使用chooseMediaPhotos替代
          adapter.wrap('chooseMediaPhotos')(Object.assign({
            type: '1',
            // 1:图片，2:视频，3:图片和视频
            maxNum: this.parent.maxAllowApp || this.maxAllowCount
          }, this.parent.chooseMediaPhotosParameter), function (data) {
            var statusCode = data.statusCode,
              imageList = data.imageList,
              mediaArray = data.data;
            if (+statusCode === 2) {
              // 准备上传
              console.log('ready to upload');
              _this4.uploadNum += 1;
              _this4.showLoading();
            } else if (+statusCode === 1) {
              // 上传成功
              var newZljMedia = mediaArray.map(function (i) {
                return {
                  imageUrl: i.photoString,
                  coverUrl: i.videoCoverString,
                  videoUrl: i.videoString
                };
              });
              console.log('success', imageList || newZljMedia);
              var files = (imageList || newZljMedia).map(function (_ref) {
                var imageUrl = _ref.imageUrl,
                  coverUrl = _ref.coverUrl,
                  videoUrl = _ref.videoUrl;
                if (coverUrl && videoUrl) {
                  // 视频
                  return {
                    progress: 1,
                    status: _util.STATUS_SUCCESS,
                    name: '',
                    type: 'video/mp4',
                    response: coverUrl,
                    url: videoUrl,
                    urlName: videoUrl
                  };
                }
                return {
                  progress: 1,
                  status: _util.STATUS_SUCCESS,
                  name: '',
                  type: 'image/jpg',
                  response: imageUrl,
                  url: imageUrl,
                  urlName: imageUrl
                };
              });
              _this4.hideLoading();
              _this4.parent.addAppFiles(files);
            } else if (+statusCode === 0) {
              // 上传失败
              console.log('error', data);
              _this4.hideLoading(_util.STATUS_ERROR);
            }
          });
        } else {
          adapter.uploadPhotos(Object.assign({
            maxNum: this.parent.maxAllowApp || this.maxAllowCount
          }, this.parent.uploadPhotoshParameter), function (data) {
            var statusCode = data.statusCode,
              imageList = data.imageList;
            if (+statusCode === 2) {
              // 准备上传
              console.log('ready to upload');
              _this4.uploadNum += 1;
              _this4.showLoading();
            } else if (+statusCode === 1) {
              // 上传成功
              console.log('success', imageList);
              var files = imageList.map(function (_ref2) {
                var imageUrl = _ref2.imageUrl;
                return {
                  progress: 1,
                  status: _util.STATUS_SUCCESS,
                  name: '',
                  type: 'image/jpg',
                  response: imageUrl,
                  url: imageUrl,
                  urlName: imageUrl
                };
              });
              _this4.hideLoading();
              _this4.parent.addAppFiles(files);
            } else if (+statusCode === 0) {
              // 上传失败
              console.log('error', data);
              _this4.hideLoading(_util.STATUS_ERROR);
            }
          });
        }
      } else {
        // 上传视频
        var onlyVideo = (this.parent.accept || this.accept).indexOf('image') === -1;

        // if (this.parent.capture || this.capture) { // 吊起摄像。app端暂时有问题，先不支持
        //   adapter.wrap('getVideoRecorder')({
        //     ...this.parent.getVideoRecorderParameter,
        //     success: data => {
        //       console.log('success', data)
        //     },
        //     fail: err => {
        //       console.log('error', err)
        //     }
        //   })
        // } else {
        //   adapter.wrap('chooseMediaPhotos')({
        //     type: onlyVideo ? '2' : '3',
        //     maxNum: this.parent.maxAllowApp || this.maxAllowCount,
        //     ...this.parent.chooseMediaPhotosParameter,
        //     success: data => {
        //       console.log('success', data)
        //     },
        //     fail: err => {
        //       console.log('error', err)
        //     }
        //   });
        // }

        adapter.wrap('chooseMediaPhotos')(Object.assign({
          type: onlyVideo ? '2' : '3',
          // 1:图片，2:视频，3:图片和视频
          maxNum: this.parent.maxAllowApp || this.maxAllowCount
        }, this.parent.chooseMediaPhotosParameter), function (data) {
          var statusCode = data.statusCode,
            imageList = data.imageList,
            videoList = data.videoList,
            mediaArray = data.data;
          if (+statusCode === 2) {
            // 准备上传
            console.log('ready to upload');
            _this4.uploadNum += 1;
            _this4.showLoading();
          } else if (+statusCode === 1) {
            // 上传成功
            var newZljMedia = mediaArray.map(function (i) {
              return {
                imageUrl: i.photoString,
                coverUrl: i.videoCoverString,
                videoUrl: i.videoString
              };
            });
            console.log('success', imageList || newZljMedia);
            var files = ((onlyVideo ? videoList : imageList) || newZljMedia).map(function (_ref3) {
              var imageUrl = _ref3.imageUrl,
                coverUrl = _ref3.coverUrl,
                videoUrl = _ref3.videoUrl;
              if (coverUrl && videoUrl) {
                // 视频
                return {
                  progress: 1,
                  status: _util.STATUS_SUCCESS,
                  name: '',
                  type: 'video/mp4',
                  response: coverUrl,
                  url: videoUrl,
                  urlName: videoUrl
                };
              }
              return {
                progress: 1,
                status: _util.STATUS_SUCCESS,
                name: '',
                type: 'image/jpg',
                response: imageUrl,
                url: imageUrl,
                urlName: imageUrl
              };
            });
            _this4.hideLoading();
            _this4.parent.addAppFiles(files);
          } else if (+statusCode === 0) {
            // 上传失败
            console.log('error', data);
            _this4.hideLoading(_util.STATUS_ERROR);
          }
        });
      }
    },
    WeixinSdkHandler: function WeixinSdkHandler() {
      var _this5 = this;
      // wx 环境上传， todo： 支持企业微信水印
      this.$nextTick(function () {
        var options = _this5.parent.uploadWeixinOptions;
        var capture = _this5.parent.capture || _this5.capture;
        var ctx = _this5.parent;
        _this5.parent.$emit(EVENT_ADDED, {});
        _this5.parent.weixinUpload.chooseImages(options, capture, ctx).then(function (data) {
          var files = data.map(function (picUrl) {
            var random = Math.ceil(Math.random() * 6);
            var file = {
              progress: 1,
              response: '',
              status: picUrl ? _util.STATUS_SUCCESS : _util.STATUS_ERROR,
              url: '',
              name: picUrl,
              type: 'image/jpg'
            };
            file.response = 'https://pic' + random + '.zhuanstatic.com/zhuanzh/' + picUrl;
            file.url = 'https://pic' + random + '.zhuanstatic.com/zhuanzh/' + picUrl;
            file.urlName = picUrl;
            return file;
          });
          if (_this5.parent.filterError) {
            files = files.filter(function (file) {
              return file.status !== _util.STATUS_ERROR;
            });
          }
          _this5.parent.addAppFiles(files);
        }).catch(function (e) {
          return _this5.parent.$emit(EVENT_ERROR, e);
        });
      });
    },
    showLoading: function showLoading() {
      if (this.stanceNum === this.uploadNum) return;
      this.parent.$emit(EVENT_ADDED, {});
      var hasStance = this.parent.files.findIndex(function (item) {
        return item === 'zzapp_stance' || item.name === 'zzapp_stance';
      }) !== -1;
      if (!hasStance) {
        this.parent.addAppFiles([(0, _util.newFile)('zzapp_stance', 1000, _util.STATUS_UPLOADING, 0.1)]);
        this.stanceNum += 1;
      }
      if (this.parent.isAppUploadLoading) {
        // 如果开启loading
        _toast.default.loading({
          mask: true,
          duration: 0,
          forbidClick: true,
          loadingType: 'spinner',
          message: '正在上传...'
        });
      }
    },
    hideLoading: function hideLoading(result) {
      if (result === void 0) {
        result = _util.STATUS_SUCCESS;
      }
      this.parent.removeFile('zzapp_stance', false);
      this.uploadNum -= 1;
      this.stanceNum -= 1;
      if (this.parent.isAppUploadLoading) {
        _toast.default.clear();
      }
      if (result === _util.STATUS_ERROR) {
        setTimeout(function () {
          (0, _toast.default)('上传失败');
        }, 500);
        this.parent.$emit(EVENT_ERROR, '');
      } else if (result === 'timeout') {
        setTimeout(function () {
          (0, _toast.default)('上传超时, 请重新上传');
        }, 500);
      }
    },
    // 处理端内上传照片(鉴定)
    handlerZZappUplaodV2: function handlerZZappUplaodV2(data) {
      var _this6 = this;
      if (data && [2, 3].includes(+data.code)) {
        // 3：压缩中；2：上传中
        this.showLoading();
      } else if (data && +data.code === 0) {
        // 处理图片
        var filesImgs = [];
        if (data.imageUrls && data.imagePaths) {
          // 本地路径
          var imagePaths = data.imagePaths.split('|');
          filesImgs = data.imageUrls.split('|').map(function (picUrl, index) {
            var random = Math.ceil(Math.random() * 6);
            var file = {
              progress: 1,
              response: '',
              status: _util.STATUS_SUCCESS,
              url: '',
              name: picUrl,
              type: 'image/jpg'
            };
            if (picUrl) {
              if (picUrl.indexOf('zhuanstatic') !== -1) {
                file.response = picUrl;
                file.url = picUrl;
              } else {
                file.response = 'https://pic' + random + '.zhuanstatic.com/zhuanzh/' + picUrl;
                file.url = 'https://pic' + random + '.zhuanstatic.com/zhuanzh/' + picUrl;
              }
              file.urlName = picUrl.indexOf('zhuanstatic') !== -1 ? picUrl.split(/zhuanzh/)[1] : picUrl;
              file.imagePath = imagePaths[index];
            } else {
              file.response = '';
              file.url = '';
              file.imagePath = '';
            }
            return file;
          });
        }
        this.hideLoading();
        // 需要先清空在添加
        this.parent.removeFileAll();
        setTimeout(function () {
          _this6.parent.addAppFiles([].concat(filesImgs));
        });
      } else if (data && +data.code === -1 && (!data.videoList || !data.videoList.length) && (!data.imageList || !data.imageList.length)) {
        // 上传全部失败
        this.hideLoading(_util.STATUS_ERROR);
      } else if (data && +data.code === -2) {
        // 取消
        this.uploadNum -= 1;
      }
    },
    // 处理端内上传照片
    handlerZZappUplaod: function handlerZZappUplaod(data) {
      var _this7 = this;
      if (!data || data.pageState) return;
      var code = data.code,
        msg = data.msg,
        fromMediaStore = data.fromMediaStore;
      if (+code === 0) {
        this.showLoading();
      } else if ([1, 2].includes(+code)) {
        if (msg) {
          var _this$parent$uploadPh;
          var files = msg.split('|').map(function (picUrl) {
            var random = Math.ceil(Math.random() * 6);
            var file = {
              progress: 1,
              response: '',
              status: _util.STATUS_SUCCESS,
              url: '',
              name: picUrl,
              type: 'image/jpg'
            };
            file.response = 'https://pic' + random + '.zhuanstatic.com/zhuanzh/' + picUrl;
            file.url = 'https://pic' + random + '.zhuanstatic.com/zhuanzh/' + picUrl;
            file.urlName = picUrl;
            return file;
          });
          // 实拍
          if (fromMediaStore) {
            var mediaMap = fromMediaStore.split('|');
            files = files.map(function (file, index) {
              file.fromMediaStore = mediaMap[index];
              return file;
            });
          }
          this.hideLoading();
          if (this.parent.filterError) {
            files = files.filter(function (file) {
              return file.status !== _util.STATUS_ERROR;
            });
          }
          if ((_this$parent$uploadPh = this.parent.uploadPhotoshParameter) !== null && _this$parent$uploadPh !== void 0 && _this$parent$uploadPh.removeBefore) {
            this.parent.removeFileAll();
            setTimeout(function () {
              _this7.parent.addAppFiles([].concat(files));
            });
          } else {
            this.parent.addAppFiles(files);
          }
        }
      } else if (+code === 3 && msg) {
        // 等于 3 说明上传全部失败
        this.hideLoading(_util.STATUS_ERROR);
      } else if (+code === -2) {
        // 取消
        this.uploadNum -= 1;
      }
    },
    // 处理新版的上传接口，支持返回上传进度
    handlerZZappUplaodV3: function handlerZZappUplaodV3(data) {
      if (!data || ![1, 2, 3, 4].includes(Number(data.code))) {
        return;
      }
      this.parent.$emit(EVENT_ADDED, {});
      var files = [];
      if (data && data.mediaList) {
        files = data.mediaList.map(function (item) {
          item.progress = item.progress ? item.progress : 0.01;
          return item;
        });
      } else {
        data.progress = data.progress ? data.progress : 0.01;
        files.push(data);
      }
      if (this.parent.disabled || this.disabled || !files.length) {
        return;
      }
      if (files.length > 0) {
        var nativeFiles = files.map(function (file) {
          return {
            progress: Number(file.code) === 3 ? 1 : Number(file.code) === 2 ? file.progress : 0.1,
            response: Number(file.code) === 3 ? "https://pic3.zhuanstatic.com/zhuanzh/" + file.imageUrl : '',
            status: ['', 'ready', 'uploading', 'success', 'error'][file.code],
            url: file.imageUrl ? "https://pic3.zhuanstatic.com/zhuanzh/" + file.imageUrl : '',
            name: file.id,
            type: 'image/jpg',
            base64: file.thumbnailBase64,
            urlName: file.imageUrl
          };
        });
        this.parent.addAppFilesV3(nativeFiles);
      }
    },
    // 处理端内上传视频
    handlerZZappUplaodMedia: function handlerZZappUplaodMedia(data) {
      console.log('handlerZZappUplaodMedia', data);
      if (!data) return;
      if ([2, 3].includes(+data.code)) {
        // 3：压缩中；2：上传中
        this.$parent.emitUploadingEvent(data);
        this.showLoading();
      } else if (+data.code === 0 || +data.code === -1 && data.videoList && data.videoList.length || +data.code === -1 && data.imageList && data.imageList.length) {
        // 处理图片
        var filesImgs = [];
        if (data.imageList) {
          filesImgs = data.imageList.map(function (item) {
            var picUrl = item.imageUrl;
            var random = Math.ceil(Math.random() * 6);
            var file = {
              progress: 1,
              response: '',
              status: _util.STATUS_SUCCESS,
              url: '',
              name: picUrl,
              type: 'image/jpg'
            };
            file.response = 'https://pic' + random + '.zhuanstatic.com/zhuanzh/' + picUrl;
            file.url = 'https://pic' + random + '.zhuanstatic.com/zhuanzh/' + picUrl;
            file.urlName = picUrl;
            // 实拍
            if (item.fromMediaStore) {
              file.fromMediaStore = item.fromMediaStore;
            }
            return file;
          });
        }
        // 处理视频
        var filesVideos = [];
        if (data.videoList) {
          filesVideos = data.videoList.map(function (item) {
            var file = {
              progress: 1,
              status: _util.STATUS_SUCCESS,
              type: 'video/mp4',
              size: item.size,
              url: item.videoUrl,
              name: item.videoUrl,
              coverMD5: item.coverMD5,
              videoMD5: item.videoMD5,
              duration: item.duration,
              coverWidth: item.coverWidth,
              coverHeight: item.coverHeight,
              urlName: item.videoUrl.split('zzwos.58cdn.com.cn')[1]
            };
            file.response = item.coverUrl.indexOf('zhuanstatic') !== -1 ? item.coverUrl : 'https://pic' + Math.ceil(Math.random() * 6) + '.zhuanstatic.com/zhuanzh/' + item.coverUrl;

            // 实拍
            if (item.fromMediaStore) {
              file.fromMediaStore = item.fromMediaStore;
            }
            return file;
          });
        }
        this.hideLoading();
        this.parent.addAppFiles([].concat(filesImgs, filesVideos));
      } else if (+data.code === -1 && (!data.videoList || !data.videoList.length) && (!data.imageList || !data.imageList.length)) {
        // 上传全部失败
        this.hideLoading(_util.STATUS_ERROR);
      } else if (+data.code === -2) {
        // 取消
        this.uploadNum -= 1;
      }
    },
    // 处理端内拍照之后上传
    handlerZZappUplaodCamera: function handlerZZappUplaodCamera(data, id) {
      if (!data || !this.cameraDict[id]) return;
      if (data.photoBase64) {
        // 伪造一个uploadFile事件，用m页的逻辑上传
        delete this.cameraDict[id];
        this.changeHandler({
          target: {
            files: [(0, _util.base64toFile)(data.photoBase64)]
          }
        });
      } else if (+data.code === -1) {
        delete this.cameraDict[id];
        this.parent.$emit(EVENT_ERROR, 'getSystemCameraError');
      } else if (+data.progress === 100) {
        delete this.cameraDict[id];
        this.parent.$emit(EVENT_ERROR, 'getSystemCameraNoReturn');
      }
    },
    // 处理m页上传
    changeHandler: function changeHandler(e) {
      var _this8 = this;
      var files = e.target.files;
      files = Array.from(files);
      if (this.parent.disabled || this.disabled || !files.length) {
        return;
      }
      if (files) {
        // 循环files来检查文件大小图片是imgMax，视频是videoMax,如果超过就删除这个文件
        try {
          files.forEach(function (file) {
            // console.log(file, 'file', this.parent.videoMax, this.parent.imgMax)
            // 如果是视频
            if (file.type.includes('video')) {
              // 如果videoMax为0，就不限制大小
              if (_this8.parent.videoMax !== 0 && file.size > _this8.parent.videoMax * 1024 * 1024) {
                // 删除这个文件
                (0, _toast.default)('视频最大' + _this8.parent.videoMax + 'M');
                files.splice(files.indexOf(file), 1);
              }
            } else {
              // 如果是图片
              // 如果imgMax为0，就不限制大小
              if (_this8.parent.imgMax !== 0 && file.size > _this8.parent.imgMax * 1024 * 1024) {
                // 删除这个文件
                (0, _toast.default)('图片最大' + _this8.parent.imgMax + 'M');
                files.splice(files.indexOf(file), 1);
              }
            }
          });
        } catch (error) {
          console.error('错误', error);
        }
        var includeVideos = Array.from(files).some(function (item) {
          return item.type.includes('video');
        });
        if (includeVideos) {
          this.parent.asyncProcessVideoFile(files, function (file) {
            _this8.parent.addFiles(file);
          });
        } else {
          this.parent.addFiles(files);
        }
        e.target.value = null;
      }
    },
    // 仅支持门店端内拍照
    ZZStoreCaptureSdkHandler: function ZZStoreCaptureSdkHandler() {
      var _this9 = this;
      this.uploadNum += 1;
      adapter.transferInfoByWebDialog({
        transferInfo: 'zhuanzhuan://jump/media/takePhoto/invoke?maxImagesCount=' + this.parent.maxAllowApp || this.maxAllowCount
      }, function (res) {
        if (!res) return;
        var id = Date.now().toString();
        _this9.cameraDict[id] = 'loading';
        var code = res.code;
        var msg = res.msg;
        var imageList = res.imageList;
        // const errorMsg = res.errorMsg
        if (+code === 0) {
          console.log('执行，上传成功');
          if (imageList) {
            var random = Math.ceil(Math.random() * 6);
            var _files = imageList.map(function (picUrl) {
              return 'https://pic' + random + '.zhuanstatic.com/zhuanzh/' + picUrl.imageUrl;
            });
            (0, _util.urlsToFiles)(_files).then(function (files) {
              var _this9$parent$uploadP;
              _this9.hideLoading();
              if (_this9.parent.filterError) {
                files = files.filter(function (file) {
                  return file.status !== _util.STATUS_ERROR;
                });
              }
              console.log(files, 'files');
              res.imageList = files;
              if ((_this9$parent$uploadP = _this9.parent.uploadPhotoshParameter) !== null && _this9$parent$uploadP !== void 0 && _this9$parent$uploadP.removeBefore) {
                _this9.parent.removeFileAll();
                setTimeout(function () {
                  _this9.handlerZZStoreAppUplaodReq(res, id);
                });
              } else {
                _this9.handlerZZStoreAppUplaodReq(res, id);
              }
            }).catch(function (error) {
              console.error('错误', error);
            });
          }
        } else if ([1, 2].includes(+code)) {
          _this9.showLoading();
        } else if (+code === -1 && msg) {
          _this9.hideLoading(_util.STATUS_ERROR);
        }
      });
    },
    // 处理门店端内普通照片上传
    ZZStoreSdkHandler: function ZZStoreSdkHandler() {
      var _this10 = this;
      if ((this.parent.accept || this.accept).indexOf('video') === -1) {
        // 上传图片
        // 直接使用老版的api
        if (this.parent.capture || this.capture) {
          // 吊起相机 - 吊的起，就是有bug，要用直接加zzStoreCapture
          // 吊起相机因为是手动上传，所以不递增 uploadNum, 单独维护一个 id
          var id = Date.now().toString();
          this.cameraDict[id] = 'loading';
          adapter.wrap('getSystemCamera')(Object.assign({}, this.parent.getSystemCameraParameter), function (data) {
            _this10.handlerZZappUplaodCamera(data, id);
          });
        } else {
          this.uploadNum += 1;
          adapter.uploadPhotos(Object.assign({
            maxAllowCount: this.parent.maxAllowApp || this.maxAllowCount
          }, this.parent.uploadPhotoshParameter), function (data) {
            _this10.handlerZZStoreAppUplaod(data);
          });
        }
      } else {
        // 上传视频 - 视频不改，跟原来保持一致
        this.uploadNum += 1;
        adapter.wrap('chooseMediaPhotos')(Object.assign({
          maxCount: this.parent.maxAllowApp || this.maxAllowCount
        }, this.parent.chooseMediaPhotosParameter), function (data) {
          _this10.handlerZZappUplaodMedia(data);
        });
      }
    },
    // 处理门店端内选择相册上传
    handlerZZStoreAppUplaod: function handlerZZStoreAppUplaod(data) {
      var _this11 = this;
      if (!data || data.pageState) return;
      var code = data.code,
        msg = data.msg;
      if (+code === 0) {
        this.showLoading();
      } else if ([1, 2].includes(+code)) {
        if (msg) {
          var random = Math.ceil(Math.random() * 6);
          var _files = msg.split('|').map(function (picUrl) {
            return 'https://pic' + random + '.zhuanstatic.com/zhuanzh/' + picUrl;
          });
          (0, _util.urlsToFiles)(_files).then(function (files) {
            var _this11$parent$upload;
            _this11.hideLoading();
            if ((_this11$parent$upload = _this11.parent.uploadPhotoshParameter) !== null && _this11$parent$upload !== void 0 && _this11$parent$upload.removeBefore) {
              _this11.parent.removeFileAll();
              setTimeout(function () {
                if (!files) return;
                if (files) {
                  // 伪造一个uploadFile事件，用m页的逻辑上传
                  _this11.changeHandler({
                    target: {
                      files: files
                    }
                  });
                }
              });
            } else {
              if (!files) return;
              if (files) {
                _this11.changeHandler({
                  target: {
                    files: files
                  }
                });
              }
            }
          }).catch(function (error) {
            _this11.hideLoading();
            console.error('错误', error);
          });
        }
      } else if (+code === 3 && msg) {
        // 等于 3 说明上传全部失败
        this.hideLoading(_util.STATUS_ERROR);
      } else if (+code === -2) {
        // 取消
        this.uploadNum -= 1;
      }
    },
    // 处理门店上传 - 拍照
    handlerZZStoreAppUplaodReq: function handlerZZStoreAppUplaodReq(data, id) {
      if (!data || !this.cameraDict[id]) return;
      if (data.imageList) {
        // 伪造一个uploadFile事件，用m页的逻辑上传
        delete this.cameraDict[id];
        this.changeHandler({
          target: {
            files: data.imageList
          }
        });
      } else if (+data.code === -1) {
        delete this.cameraDict[id];
        this.parent.$emit(EVENT_ERROR, 'getSystemCameraError');
      } else if (+data.progress === 100) {
        delete this.cameraDict[id];
        this.parent.$emit(EVENT_ERROR, 'getSystemCameraNoReturn');
      }
    }
  }
};
exports.default = _default;